import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Store, BookOpen, MessageSquare, User } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
export function BottomNav() {
  const navItems = [{
    path: '/app',
    icon: Home,
    label: 'Home',
    end: true
  }, {
    path: '/app/marketplace',
    icon: Store,
    label: 'Market'
  }, {
    path: '/app/training',
    icon: BookOpen,
    label: 'Learn'
  }, {
    path: '/app/messages',
    icon: MessageSquare,
    label: 'Chat'
  }, {
    path: '/app/profile',
    icon: User,
    label: 'Profile'
  }];
  return <nav className="fixed bottom-0 w-full max-w-md bg-white border-t border-gray-100 pb-safe pt-2 px-4 z-50 shadow-[0_-4px_20px_-10px_rgba(0,0,0,0.05)]" data-id="element-42">
      <div className="flex justify-between items-center h-14" data-id="element-43">
        {navItems.map(item => <NavLink key={item.path} to={item.path} end={item.end} className={({
        isActive
      }) => twMerge('flex flex-col items-center justify-center w-16 h-full transition-colors', isActive ? 'text-brand-primary' : 'text-text-secondary hover:text-text-primary')} data-id="element-44">
            {({
          isActive
        }) => <>
                <item.icon className={twMerge('w-6 h-6 mb-1 transition-transform', isActive && 'scale-110')} strokeWidth={isActive ? 2.5 : 2} data-id="element-45" />
                <span className={twMerge('text-[10px] font-medium', isActive && 'font-bold')} data-id="element-46">
                  {item.label}
                </span>
              </>}
          </NavLink>)}
      </div>
    </nav>;
}